// code-reaper-ignore-file -- Uses `useLayoutEffect` in the browser and `useEffect` in the server.

import { useLayoutEffect } from 'react';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export default useLayoutEffect;
